import { FC, MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@robocorp/theme';
import { IconCheck2, IconCopy } from '@robocorp/icons/iconic';
import { Box, Input, useClipboard } from '@robocorp/components';

const Container = styled(Box)`
  label span {
    text-transform: initial;

    &::first-letter {
      text-transform: capitalize;
    }
  }
`;

type Props = {
  label: string;
  value?: string;
};

export const ApiHelperInput: FC<Props> = ({ label, value }) => {
  const { t } = useTranslation();
  const { onCopyToClipboard, copiedToClipboard } = useClipboard();

  const onInputClick = useCallback((e: MouseEvent<HTMLInputElement>) => {
    const input = e.currentTarget;

    input.selectionStart = 0;
    input.selectionEnd = input.value.length;
  }, []);

  return (
    <Container mb={12}>
      <Input
        onClick={onInputClick}
        label={label}
        placeholder={t('notSet')}
        value={value}
        iconRight={copiedToClipboard ? IconCheck2 : IconCopy}
        onIconRightClick={value ? onCopyToClipboard(value) : undefined}
        iconRightLabel={t('copyToClipboard')}
        disabled={!value}
        readOnly
      />
    </Container>
  );
};
